import { render, staticRenderFns } from "./HorseBilanSaison.vue?vue&type=template&id=4aaaff4f&"
import script from "./HorseBilanSaison.vue?vue&type=script&lang=js&"
export * from "./HorseBilanSaison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports